import React, { Component } from 'react';
import DelayLink from './DelayLink';

class Thumbnail extends Component {
	render() {
		const thumbImage = require('../assets/images/thumbs/' + this.props.project.thumbnail);
		var sectionStyle = {
			backgroundImage: `url(${thumbImage})`
		};
		return (
			<article className={'thumbnail hoverable'}>
				<DelayLink
					to={this.props.project.url}
					className="thumbnail__link hoverable"
					delay={300}
					onDelayStart={() => {
						document.getElementById('root').className = 'leave-to_project';
					}}
					onDelayEnd={() => {
						document.getElementById('root').className = '';
					}}
				>
					<div style={sectionStyle} className="thumbnail__image" />
					<h3 className="thumbnail__title">{this.props.project.name}</h3>
					<span className="thumbnail__description">{this.props.project.description}</span>
				</DelayLink>
			</article>
		);
	}
}

export default Thumbnail;
